import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  "public-alt": defineAsyncComponent(() => import("/vercel/path0/layouts/public-alt.vue").then(m => m.default || m)),
  "public-home": defineAsyncComponent(() => import("/vercel/path0/layouts/public-home.vue").then(m => m.default || m)),
  "public-min": defineAsyncComponent(() => import("/vercel/path0/layouts/public-min.vue").then(m => m.default || m))
}